import { SITE } from '@/lib/site'
import type { ResolvedSeo } from './types'

export const SEO_SITE_NAME = SITE.legalName

export const GLOBAL_DEFAULT_SEO: ResolvedSeo = {
  title: "Quick Build Con | Gujarat's Real Estate Network for Buyers & Sellers",
  description:
    'Find verified residential and commercial properties across Gujarat and India. Search flats, plots, villas, offices, shops and projects with QBC Verified listings.',
  ogType: 'website',
  ogLocale: 'en_IN',
  siteName: SEO_SITE_NAME,
  twitterCard: 'summary_large_image',
  noIndex: false,
  noFollow: false,
}

export const PRIVATE_PAGE_SEO: Pick<ResolvedSeo, 'noIndex' | 'noFollow'> = {
  noIndex: true,
  noFollow: true,
}
